export enum ButtonThemeEnum {
  DEFAULT,
  DEFAULT_INNER,
  SAVE,
  SAVE_INNER,
  CANCEL,
  CANCEL_INNER,
  VALIDATE,
  VALIDATE_INNER,
  ERROR,
  ERROR_INNER,
  WARNING,
  WARNING_INNER,
  SUCCESS,
  SUCCESS_INNER,
  EMPTY,
  EMPTY_INNER
}

export const ButtonThemeLabel: Record<ButtonThemeEnum, string> = {
  [ButtonThemeEnum.DEFAULT]: "default",
  [ButtonThemeEnum.DEFAULT_INNER]: "default-inner",
  [ButtonThemeEnum.VALIDATE]: "validate",
  [ButtonThemeEnum.VALIDATE_INNER]: "validate-inner",
  [ButtonThemeEnum.CANCEL]: "cancel",
  [ButtonThemeEnum.CANCEL_INNER]: "cancel-inner",
  [ButtonThemeEnum.SAVE]: "save",
  [ButtonThemeEnum.SAVE_INNER]: "save-inner",
  [ButtonThemeEnum.ERROR]: "error",
  [ButtonThemeEnum.ERROR_INNER]: "error-inner",
  [ButtonThemeEnum.WARNING]: "warning",
  [ButtonThemeEnum.WARNING_INNER]: "warning-inner",
  [ButtonThemeEnum.SUCCESS]: "success",
  [ButtonThemeEnum.SUCCESS_INNER]: "success-inner",
  [ButtonThemeEnum.EMPTY]: "empty",
  [ButtonThemeEnum.EMPTY_INNER]: "empty-inner",
}
